/**
 * @generated SignedSource<<7a499cebaf242e7f0cfca2146cc982ff>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from 'relay-runtime';
export type ProductRegistrationProfileStepGuestMutation$variables = {
  id: string;
};
export type ProductRegistrationProfileStepGuestMutation$data = {
  readonly completeGuestCheckout: {
    readonly errors: ReadonlyArray<{
      readonly field: string;
      readonly message: string;
    }> | null;
    readonly node: {
      readonly id: string;
    } | null;
  };
};
export type ProductRegistrationProfileStepGuestMutation = {
  response: ProductRegistrationProfileStepGuestMutation$data;
  variables: ProductRegistrationProfileStepGuestMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "id"
  }
],
v1 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "id",
        "variableName": "id"
      }
    ],
    "concreteType": "CompleteGuestCheckoutResponse",
    "kind": "LinkedField",
    "name": "completeGuestCheckout",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "UserMembership",
        "kind": "LinkedField",
        "name": "node",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "id",
            "storageKey": null
          }
        ],
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "concreteType": "ValidationError",
        "kind": "LinkedField",
        "name": "errors",
        "plural": true,
        "selections": [
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "field",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "message",
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "ProductRegistrationProfileStepGuestMutation",
    "selections": (v1/*: any*/),
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "ProductRegistrationProfileStepGuestMutation",
    "selections": (v1/*: any*/)
  },
  "params": {
    "cacheID": "7de2ad97690b8cd770a968a369c4ad0c",
    "id": null,
    "metadata": {},
    "name": "ProductRegistrationProfileStepGuestMutation",
    "operationKind": "mutation",
    "text": "mutation ProductRegistrationProfileStepGuestMutation(\n  $id: ID!\n) {\n  completeGuestCheckout(id: $id) {\n    node {\n      id\n    }\n    errors {\n      field\n      message\n    }\n  }\n}\n"
  }
};
})();

(node as any).hash = "5d675a612597bc6fc16970867813ff99";

export default node;
